import { WarningAmber } from "@mui/icons-material";
import { Alert, Box } from "@mui/material";
import React from "react";
import { getFormattedDateTime } from "utils/helper";
import { getEnrichedRows } from "./helper";

const AlertBox = ({ rows }) => {
  const enrichedRows = getEnrichedRows(rows);

  const latestJob = enrichedRows?.[0];
  const latestIsOld = latestJob?.isOlderThan1Day;
  return (
    <Box mb={2}>
      {latestJob ? (
        latestIsOld ? (
          <Alert
            severity="error"
            icon={<WarningAmber />}
            sx={{
              fontWeight: 600,
              "& .MuiAlert-message": { width: "100%" },
            }}
          >
            Latest appointment load is more than 1 day old.
            <Box mt={0.5}>
              Last run: {getFormattedDateTime(latestJob.job_run_date)}
            </Box>
          </Alert>
        ) : (
          <Alert severity="success" sx={{ fontWeight: 600 }}>
            Latest appointment load is recent.
            <Box mt={0.5}>
              Last run: {getFormattedDateTime(latestJob.job_run_date)}
            </Box>
          </Alert>
        )
      ) : (
        <Alert severity="info">No load details found.</Alert>
      )}
    </Box>
  );
};

export default AlertBox;
